import { jsxs, jsx } from 'react/jsx-runtime';
import { preventForwardPropsConfig } from '../utils/preventForwardProps.js';
import { forwardRef } from 'react';
import { styled, css } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { Label } from './Label.js';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { mediaHover } from '../constants/styled-utils.js';

const SwitchThumb = styled(SwitchPrimitive.Thumb).withConfig({
  displayName: "Switch__SwitchThumb",
  componentId: "sc-73f387b2-0"
})([
  `display:block;border-radius:9999px;background-color:`,
  `;transition:transform 100ms;will-change:transform;`
], cssVar["color-bg-primary"]);
const cssVariant = css([
  `&[data-state='checked']{`,
  `}`
], (p) => {
  switch (p.variant) {
    case "success":
      return css([
        `background-color:`,
        `;`
      ], cssVar["color-app-success"]);
    default:
      return css([
        `background-color:`,
        `;`
      ], cssVar["color-bg-nonary"]);
  }
});
const cssSize = css([
  ``,
  ``
], (p) => {
  switch (p.size) {
    case "18":
      return css([
        `width:29px;height:18px;`,
        `{width:14px;height:14px;transform:translateX(2px);&[data-state='checked']{transform:translateX(13px);}}`
      ], SwitchThumb);
    default:
      return css([
        `width:44px;height:24px;`,
        `{width:20px;height:20px;transform:translateX(2px);&[data-state='checked']{transform:translateX(22px);}}`
      ], SwitchThumb);
  }
});
const SwitchRoot = styled(SwitchPrimitive.Root).withConfig({
  displayName: "Switch__SwitchRoot",
  componentId: "sc-73f387b2-1"
})([
  `display:inline-block;`,
  `;background-color:`,
  `;`,
  `;border-radius:9999px;position:relative;transition:background-color 100ms,box-shadow 200ms;will-change:background-color box-shadow;`,
  `{&:hover:enabled{box-shadow:0 0 10rem 0 rgba(`,
  `,0.1) inset;}}&[data-state='checked']{`,
  `{&:hover:enabled{box-shadow:0 0 10rem 0 rgba(`,
  `,0.1) inset;}}}&:disabled{opacity:0.5;cursor:not-allowed;pointer-events:none;}`
], cssSize, cssVar["color-bg-quarternary"], cssVariant, mediaHover, cssVar["color-bg-primary-reverse-rgb"], mediaHover, cssVar["color-bg-primary-rgb"]);
const SwitchLabel = styled(Label).withConfig(preventForwardPropsConfig([
  "disabled"
])).withConfig({
  displayName: "Switch__SwitchLabel",
  componentId: "sc-73f387b2-2"
})([
  `display:flex;align-items:center;gap:8px;cursor:pointer;color:`,
  `;`,
  ``
], cssVar["color-text-primary"], ({ disabled }) => disabled && css([
  `opacity:0.5;cursor:not-allowed;pointer-events:none;`
]));
const Switch = /* @__PURE__ */ forwardRef(({ children: _, label = "", ...props }, forwardedRef) => /* @__PURE__ */ jsxs(SwitchLabel, {
  disabled: props.disabled,
  children: [
    /* @__PURE__ */ jsx(SwitchRoot, {
      ...props,
      ref: forwardedRef,
      children: /* @__PURE__ */ jsx(SwitchThumb, {})
    }),
    label
  ]
}));
Switch.displayName = "Switch";
const Switch$1 = Object.assign(Switch, {
  Root: SwitchRoot,
  Thumb: SwitchThumb
});

export { Switch$1 as default };
//# sourceMappingURL=Switch.js.map
